<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Season of Sacrifice</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<p class="epigraph">‘Truth exists, only falsehood has to be invented.’</p>
<p class="epigraph-source-space-after">Georges Braque</p>
<p class="epigraph">‘We do not live an equal life, but one of contrasts and patchwork; now a little joy, then a sorrow, now a sin, then a generous or brave action.’</p>
<p class="epigraph-source">Ralph Waldo Emerson</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?61fe0ffd